// import external dependencies
import 'jquery'

// Import everything from autoload
import './autoload/_bootstrap.js'

import '@fancyapps/fancybox'
import 'jquery-match-height'
import 'slick-carousel'
// import local dependencies
import Router from './util/Router'
import common from './routes/common'
import home from './routes/home'
import swiper_ilo_design from './swiper_ilo_design';
import template_linteau from './template_linteau';
import aboutUs from './routes/about'
import singleProduit from './routes/singleProduit'
import templateVente from './routes/templateVente'
import singleTravaux from './routes/singleTravaux'
import templateDownload from './routes/templateDownload';
// import ajaxBlogFilter from './routes/ajaxBlogFilter'
import templateBlog from './routes/templateBlog';

/** Populate Router instance with DOM routes */
const routes = new Router({
	// All pages
	common,
	// Home page
	home,
	// About Us page, note the change from about-us to aboutUs.
	aboutUs,

	singleProduit,

	templateVente,

	singleTravaux,

	templateDownload,

	// ajaxBlogFilter

	templateBlog,

})

// Load Events
jQuery(document).ready(() => routes.loadEvents())
swiper_ilo_design();
template_linteau();


// WEBPACK FOOTER //
// ./scripts/main.js